<template lang="pug">
  .layout-view
    template(v-if="!isMobile")
      .layout-view__controls
        v-btn(
          medium
          :yellow="hasFilters"
          @click="modals.showFilters = true")
          v-icon(
            position-left
            font-size="1"
            icon="filter").mr-1
          span {{ 'base.add_filter' | translate }}
        v-btn.ml-2(
          :disabled="isConsultant"
          medium
          @click="modals.showCreateNew = true")
          v-icon(
            position-left
            font-size="1"
            icon="plus").mr-1
          span {{ 'base.add_to_stock' | translate }}
    template(v-else)
      v-btn(
        :disabled="isConsultant"
        fab
        @click="modals.showCreateNew = true")
        v-icon(
          font-size="1.2"
          icon="plus")
      v-btn(
        fab
        :yellow="hasFilters"
        @click="modals.showFilters = true")
        v-icon(
          font-size="1.2"
          icon="filter")
    v-dialog(
      max-width="520"
      v-model="modals.showFilters")
      filters-modal(
        @close="modals.showFilters = false")
    v-dialog(
      max-width="420"
      v-model="modals.showCreateNew") 
      create-modal(
        @close="modals.showCreateNew = false")
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import { mapGetters } from 'vuex'

import FiltersModal from './modals/FiltersModal'
import CreateModal from './modals/CreateModal'

export default {
  name: 'ControlsPanel',

  mixins: [adaptationMixin],

  components: {
    FiltersModal,
    CreateModal
  },

  data: () => ({
    modals: {
      showFilters: false,
      showCreateNew: false
    }
  }),

  computed: {
    ...mapGetters('deliveries', [
      'hasFilters'
    ])
  }
}
</script>
